import { Form } from 'factorial-form'

class Email extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      email: 'string',
      unconfirmed_email: 'string',
    })
  }
}

export default Email
